// TODO: HTTP Error handling
export const fetchDataset = async (uuid) =>
  fetch(
    "https://api.resourcewatch.org/v1/dataset/" +
      uuid +
      "?includes=layer,metadata"
  )
    .then((response) => response.json())
    .then((response) => response.data.attributes);
